export const CONNECTOR_SIGNUP_EMAIL_STORAGE_KEY = 'jnavi.connectorSignupEmail'

export const CONNECTOR_SIGNUP_PENDING_NOTICE =
  'コネクター登録を受け付けました。確認メールのリンクでメール認証を行ったあと、この画面でメールアドレスとパスワードを入力してログインしてください。代理店申請は不要です。'

export const CONNECTOR_SIGNUP_READY_NOTICE =
  'コネクター登録が完了しました。この画面でメールアドレスとパスワードを入力してログインしてください。'

export const CONNECTOR_EMAIL_CONFIRMED_NOTICE =
  'メール認証が完了しました。メールアドレスとパスワードを入力してログインしてください。'
